import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

/**
 * Register a new customer via POS registration endpoint.
 * POST /dsok/customer/register
 * @param {Object} payload - { step1, step2, step3, step4 }
 * @returns {Promise<{ data: { ok?: boolean, message?: string, data?: { customerId?: number } } }>}
 */
export async function registerDSOKCustomer(payload) {
  setBackendDomain(jwtAuthAxios);
  return jwtAuthAxios.post("/dsok/customer/register", payload);
}

/**
 * Look a company up by IČO (register proxy) to prefill the new-customer form.
 * GET /dsok/customer/lookup/:ico
 * @param {string} ico
 * @returns {Promise<{ data: { company: object, warning: string|null } }>}
 */
export async function lookupCompanyByIco(ico) {
  setBackendDomain(jwtAuthAxios);
  return jwtAuthAxios.get(
    `/dsok/customer/lookup/${encodeURIComponent(String(ico || "").trim())}`,
  );
}
